import { useState, useEffect } from 'react'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { getPaymentRequirementSettings } from '@user/store/closingRequirements/api'
import { ClosingPaymentRequirementsModel } from '@user/store/closingRequirements/typings'
import { unwrapResult } from '@reduxjs/toolkit'

export const useGetPaymentRequirementsOnMount = () => {
  const dispatch = useAppDispatch()

  const [status, setStatus] = useState<'pending' | 'success' | 'fail'>(
    'pending',
  )

  const [paymentRequirements, setPaymentRequirements] = useState<
    ClosingPaymentRequirementsModel[]
  >([])

  useEffect(() => {
    let mounted = true

    const execute = async () => {
      try {
        setStatus('pending')

        const result = await dispatch(getPaymentRequirementSettings())

        if (mounted) {
          if (getPaymentRequirementSettings.fulfilled.match(result)) {
            setPaymentRequirements(unwrapResult(result))
            setStatus('success')
          } else {
            setStatus('fail')
          }
        }
      } catch {
        if (mounted) {
          setStatus('fail')
        }
      }
    }
    execute()

    return () => {
      mounted = false
    }
  }, [dispatch])

  return { paymentRequirementsStatus: status, paymentRequirements }
}
